import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type AuthEmailServiceInput = {
  payload: {
    email?: string
  }
}

export const authEmailService = async ({
  payload,
}: AuthEmailServiceInput): Promise<ResponseAPI> => {
  const response = await api.get(`validaemail/${payload.email}`)

  return response.data
}
